import { TextField, Autocomplete } from "@mui/material";
import React, {forwardRef} from "react";
import { Enum } from "src/common/enum/Enum";
import CircularProgress from '@mui/material/CircularProgress';

interface AddressFormAutocompleteProps {
  value?: any;
  defaultValue?: any;
  filterOptions?: any;
  onInputChange?: any;
  getOptionLabel?: any;
  isOptionEqualToValue?: any;
  onChange?: any;
  error: boolean;
  loading?: boolean;
  helperText?: string;
  options: Enum[];
  label?: string;
  disabled?: boolean;
  disableClearable?: boolean;
  required?: boolean;
  size?: "small" | "medium";
  style?: any;
}

export const AddressFormAutocomplete = forwardRef((props: AddressFormAutocompleteProps, ref) => {
  const {
    label,
    error = false,
    loading = false,
    helperText,
    options,
    onChange,
    disabled = false,
    disableClearable = true,
    required = false,
    size = "medium",
    style = {},
    ...rest
  } = props;

  return (
    <Autocomplete
      autoHighlight
      autoSelect
      disabled={disabled}
      disableClearable={disableClearable}
      options={options}
      size={size}
      loading={loading}
      style={style}
      isOptionEqualToValue={(option, value) => {
        return option.id === value;
      }}
      getOptionLabel={(option) => option?.name || options.find((x) => x.id === option)?.name || ''}
      renderInput={(params) => (
        <TextField
          {...rest}
          {...params}
          size={size}
          label={label}
          error={error}
          required={required}
          helperText={helperText}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
      {...rest}
      onChange={onChange}
    />
  );
});